import { useEffect, useState } from 'react';

import {
  clearSyncDoneBanner,
  shouldShowSyncDoneBanner,
} from '../../hooks/use-sync-progress-modal';
import { openSyncProgressModal } from '../../sync-events';
import { useSyncJobContext } from '../../sync-job/sync-job-provider';
import {
  isActiveSyncPhase,
  isResumableSyncPhase,
  isTerminalSyncPhase,
} from '../../sync-job/types';

import { SyncStatusStrip } from '../sync-status-strip/sync-status-strip';

const DONE_BANNER_MS = 12_000;

export function SyncResumeBanner() {
  const { job, isRunning, resumeJob } = useSyncJobContext();
  const [showDone, setShowDone] = useState(() => shouldShowSyncDoneBanner());

  useEffect(() => {
    if (!job || !isTerminalSyncPhase(job.status) || !shouldShowSyncDoneBanner()) {
      return;
    }
    setShowDone(true);
    const timer = window.setTimeout(() => {
      clearSyncDoneBanner();
      setShowDone(false);
    }, DONE_BANNER_MS);
    return () => window.clearTimeout(timer);
  }, [job?.status]);

  if (!job) {
    return null;
  }

  const showActive =
    isRunning ||
    isActiveSyncPhase(job.status) ||
    isResumableSyncPhase(job.status);

  const showTerminal = showDone && isTerminalSyncPhase(job.status);

  if (!showActive && !showTerminal) {
    return null;
  }

  const handleOpen = () => {
    openSyncProgressModal();
    if (showTerminal) {
      clearSyncDoneBanner();
      setShowDone(false);
    }
  };

  return (
    <SyncStatusStrip
      job={job}
      isRunning={isRunning}
      variant="banner"
      onOpenDetails={handleOpen}
      onResume={job.status === 'paused' ? () => resumeJob() : undefined}
    />
  );
}

export default SyncResumeBanner;
